import { render } from "./ContactDetailsOpportunitiesTab.vue?vue&type=template&id=e45282be"
import script from "./ContactDetailsOpportunitiesTab.vue?vue&type=script&lang=js"
export * from "./ContactDetailsOpportunitiesTab.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__